import {
  makeStyles,
  MenuItem,
  shorthands,
  Tag,
  tagClassNames,
  tokens,
  useIsOverflowItemVisible,
} from "@fluentui/react-components";
import { useSetAtom } from "jotai";
import { selectedPackageUserAtom } from "store/UIBenefitsPage";

const useMenuItemStyles = makeStyles({
  menuItem: {
    padding: `${tokens.spacingVerticalSNudge} ${tokens.spacingHorizontalXS}`,
    ":hover": {
      [`& .${tagClassNames.root}`]: {
        color: tokens.colorNeutralForeground2Hover,
      },
    },
  },
  tag: {
    backgroundColor: "transparent",
    ...shorthands.borderColor("transparent"),
  },
});

export const OverflowMenuItem = ({ tag }) => {
  const isVisible = useIsOverflowItemVisible(tag.value!);
  const setSelectedUser = useSetAtom(selectedPackageUserAtom);

  const styles = useMenuItemStyles();

  if (isVisible) {
    return null;
  }
  return (
    <MenuItem
      key={tag.value}
      className={styles.menuItem}
      onClick={() => {
        setSelectedUser(tag.data);
      }}
    >
      <Tag {...tag} as="span" className={styles.tag} />
    </MenuItem>
  );
};
